import React from "react";
import styled from "styled-components";

// Styled Components
const Section = styled.section`
  padding: 60px 20px;
  background-color: #fff;
  color: #111;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #111;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 40px;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

const Card = styled.div`
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgb(88, 199, 192);
  }
`;

const Icon = styled.div`
  font-size: 2rem;
  margin-bottom: 15px;
  color: #007bff;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

const CardContent = styled.p`
  font-size: 0.95rem;
  color: #555;
`;

const WhyChooseUs = () => {
  const features = [
    {
      icon: "⚡",
      title: "AI-Powered Optimization",
      content: "Reduce delivery times by 30-50% with smarter inventory placement.",
    },
    {
      icon: "📍",
      title: "Hyperlocalized Fulfillment",
      content: "Meet customer demand faster through strategically placed micro-hubs.",
    },
    {
      icon: "💰",
      title: "Cost-Effective Operations",
      content: "Minimize excess inventory and reduce operational costs.",
    },
    {
      icon: "📈",
      title: "Scalable Solution",
      content: "Adapt and grow seamlessly as you expand your hyperlocal delivery network.",
    },
    {
      icon: "📊",
      title: "Actionable Insights",
      content: "Access real-time analytics to drive decisions and improve inventory efficiency.",
    },
  ];

  return (
    <Section>
      <Title>Why Choose Us?</Title>
      <Subtitle>
        Our solutions empower your business with efficiency, scalability, and actionable insights.
      </Subtitle>
      <CardContainer>
        {features.map((feature, index) => (
          <Card key={index}>
            <Icon>{feature.icon}</Icon>
            <CardTitle>{feature.title}</CardTitle>
            <CardContent>{feature.content}</CardContent>
          </Card>
        ))}
      </CardContainer>
    </Section>
  );
};

export default WhyChooseUs;
